function initHeaderNav(header) {
  const bar = header.querySelector('.site-header__bar');
  const toggle = header.querySelector('.site-header__toggle');
  const nav = header.querySelector('.site-header__nav');
  if (!bar || !toggle || !nav) return;

  function closeMenu() {
    bar.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-label', 'Open menu');
  }

  function openMenu() {
    bar.classList.add('is-open');
    toggle.setAttribute('aria-expanded', 'true');
    toggle.setAttribute('aria-label', 'Close menu');
  }

  toggle.addEventListener('click', () => {
    const isOpen = bar.classList.contains('is-open');
    if (isOpen) {
      closeMenu();
    } else {
      openMenu();
    }
  });

  nav.addEventListener('click', (event) => {
    if (event.target.closest('a')) closeMenu();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && bar.classList.contains('is-open')) {
      closeMenu();
      toggle.focus();
    }
  });

  document.addEventListener('click', (event) => {
    if (bar.classList.contains('is-open') && !bar.contains(event.target)) {
      closeMenu();
    }
  });

  window.addEventListener('resize', () => {
    if (window.innerWidth > 767) closeMenu();
  });
}

function initReviewsCarousel(track) {
  const cards = [...track.querySelectorAll('.home-reviews__card')];
  if (!cards.length) return;

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          entry.target.classList.toggle('home-reviews__card--active', entry.intersectionRatio > 0.6);
        });
      },
      { root: track, threshold: [0, 0.6, 1] }
    );
    cards.forEach((card) => observer.observe(card));
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.site-header');
  if (header) initHeaderNav(header);

  const reviewsCarousel = document.querySelector('.home-reviews__carousel');
  if (reviewsCarousel) initReviewsCarousel(reviewsCarousel);

  /*
    The product gallery + variant picker + add-to-cart logic lives in
    sections/a-lumora-product-hero.liquid's own inline <script>, scoped per
    instance via document.currentScript.closest('.product-hero') — not here.
    A single global document.querySelector('.product-hero__gallery') is
    unreliable when Shopify's theme editor renders more than one copy of a
    section's markup (e.g. drag-reorder previews), so gallery interactions
    are kept section-scoped instead.
  */
});
